@if (shouldShowIconBar()) {
  <div
    class="icon-bar d-none d-md-flex position-fixed border-top border-end border-bottom shadow"
    [class.icon-bar-with-text]="showIconText()">
    <div
      class="icon-bar-menu d-flex flex-column p-m gap-1"
      [class.align-items-center]="!showIconText()">
      @for (icon of visibleUserMenuItems(); track icon.type) {
        <app-tooltip
          [text]="(icon.name | translate)"
          [opensOn]="'Auto'"
          [position]="'RightCenter'">
          <app-form-button
            [style]="'btn'"
            [cssClass]="showIconText() ? 'btn-link icon-bar-button justify-content-start text-start p-m gap-2 w-100' : 'btn-link p-m'"
            [iconClass]="'text-' + icon.color + ' fs-4'"
            [icon]="icon.icon"
            [text]="(icon.name | translate)"
            [textClass]="showIconText() ? 'text-primary icon-bar-title' : 'visually-hidden'"
            (click)="onMenuItemClick(icon)">
          </app-form-button>
        </app-tooltip>
      }
    </div>
    @if (shouldShowIconTextToggle()) {
      <div class="icon-bar-toggle-column">
        <button
          type="button"
          class="btn btn-link icon-bar-toggle-button p-0"
          [attr.aria-label]="iconTextToggleLabel()"
          [attr.aria-expanded]="showIconText()"
          (click)="toggleIconText()">
          <span class="mts-icon notranslate fs-5" aria-hidden="true" translate="no">{{ iconTextToggleIcon() }}</span>
        </button>
      </div>
    }
  </div>
}

@if (homeLinksDialogVisible()) {
  <app-dialog-home-links-all
    [visible]="homeLinksDialogVisible()"
    (visibleChange)="homeLinksDialogVisible.set($event)">
  </app-dialog-home-links-all>
}
